import {
  arabicThemeClass,
  cyrillicThemeClass,
  southAsiaThemeClass,
} from "./theme.css";

export const LOCALE_TO_THEME_CLASS: Readonly<Record<string, string>> = {
  ar: arabicThemeClass,
  ur: arabicThemeClass,
  uk: cyrillicThemeClass,
  zh: southAsiaThemeClass,
};

export const fontThemeClassForLocale = (locale?: string): string | null => {
  if (!locale) return null;
  const normalized = locale.toLowerCase().replace(/_/g, "-");
  if (LOCALE_TO_THEME_CLASS[normalized]) {
    return LOCALE_TO_THEME_CLASS[normalized];
  }
  const language = normalized.split("-")[0];
  return LOCALE_TO_THEME_CLASS[language] ?? null;
};
